import { createStore } from "vuex";
import { stepper } from "./stepper.moduleStore";
import authOnboarding from "./authOnboarding";

export default createStore({
  modules: {
    stepper,
    authOnboarding,
  },
});
